module.exports = __webpack_public_path__ + "img/s.b0aa4d9e.jpg";